<template>
  <div class="invite-main">
    <div class="bg">
      <div class="main">
        <div class="banner" v-if="lang=='cn'"></div>
        <div class="banner1" v-if="lang=='hk'"></div>
      </div>
    </div>
    <div class="content">
      <div class="main">
        <div class="record">
          <div class="detail">
            <p>{{$t('label.w208')}}：<span>{{TotalCount}}</span>人</p>
            <p>{{$t('label.w209')}}：<span>{{TotalAmount}}</span>元</p>
            <p>{{$t('label.w207')}}:<span>{{assets.OwerId}}</span></p>
          </div>
          <div class="invite"><span>{{$t('label.w210')}}:</span><span class="s1" id="url">{{url}}</span>
          <Button 
            @click="copy"
            data-clipboard-target="#url"
            :data-clipboard-text="this.url"
            class="btn"
          >{{$t('btn.b80')}}</Button></div>
          <div class="activeBtn">
              <Button @click="see()">{{$t('btn.b81')}}</Button>
              <Button class="b2" @click="()=>this.$router.push({name:'inviteDetail'})">{{$t('btn.b82')}}</Button>
          </div>
        </div>
        <div class="record-list">
          <div>
            <span class="s1" :class="{active:type=='invite'}" @click="type='invite'">{{$t('label.w212')}}</span> 
            <span class="s1" :class="{active:type=='reward'}" @click="type='reward'">{{$t('label.w213')}}</span>
          </div>
          <div class="ir-list" v-show="type=='invite'">
            <Datatable :th="[$t('label.w214'), $t('label.w215') , $t('label.w216')]" field="InvitedList"  url='/Member/RZJFund/InvitedUserRecord' v-slot="{item}" @on-data="inviteNum" :tip="$t('msg.m129')">
                <tr>
                  <td width='15%'>{{item.Index}}</td>
                  <td width='60%'>{{item.RealName}}</td>
                  <td>{{item.CreatedAt}}</td>
                </tr>
            </Datatable>
          </div>
          <div v-show="type=='reward'" class="ir-list">
            <Datatable :th="[ $t('label.w217') , $t('label.w218') ,$t('label.w219')]" field="InvitedAwardRecord" url='/Member/RZJFund/MyInvitedAwardRecord' v-slot="{item}" @on-data="rewardNum" :tip="$t('msg.m130')">
              <tr>
                <td  width='20%'>{{item.CreatedAt}}</td>
                <td  width='50%'>{{item.Type== 0 ? $t('option.w69'):$t('option.w70')}}</td>
                <td>{{item.AwardAmount | money}}</td>
              </tr>
            </Datatable>
          </div>
        </div>
      </div>
    </div>
    <PostModal ref='postmodal' :imgurl="posturl"></PostModal>
  </div>
</template>

<script>
import Datatable from '@/components/datatable'
import PostModal from './postModal'
import Clipboard from "clipboard";
export default {
  components: { Datatable , PostModal},
  data(){
    return{
      type: 'invite',
      TotalAmount:'',
      TotalCount:'',
      posturl:''
    }
  },
  methods:{
    inviteNum(res){
      this.TotalCount = res.Pager.TotalCount
    },
    rewardNum(res){
      this.TotalAmount = res.TotalAmount
    },
    copy() {
      let clipboard = new Clipboard(".btn");
      //因为var是全局变量，let和const是局部
      clipboard.on("success", e => {
        this.$Message.success(this.$t('msg.m127'))
        clipboard.destroy(); //使用destroy可以清楚缓存
      });
      clipboard.on("error", e => {
        this.$Message.error(this.$t('msg.m128'))
        clipboard.destroy();
      });
    },
    see(){
      this.$refs.postmodal.modal = true;
    },
    post(){
      this.$axios.get('/Member/RZJFund/GetInvitePoster')
      .then(res => {
        if (res.err) return res.throw();
        this.posturl = res
      })
    }
  },
  mounted() {
    this.post()
  },
  computed: {
    lang() {
      return this.$i18n.locale;
    },
    url(){
      // return `http://localhost:8000/dist/#/account/register?inviteId=${this.assets.OwerId}`
      return `${this.safe.WebURL}/#/account/register?inviteId=${this.assets.OwerId}`
    },
    assets(){
      return this.$store.state.user.assets
    },
    safe(){
      return this.$store.state.user.safe
    }
  }
};
</script>

<style lang="less" scoped>
.invite-main {
  background: #F1F2F5;
  .main {
    width: 1200px;
    margin: 0 auto;
  }
  .bg {
    height: 564px;
    background: url("../../assets/invite/bg.png");
    background-size: 100%;
    .banner {
      background: url("../../assets/invite/banner.png");
      height: 453px;
    }
    .banner1{
      background: url("../../assets/invite/banner1.png");
      height: 453px;
    }
  }
  .content{
    .record{
      height: 466px;
      background: #fff;
      margin-top: -80px;
      border-radius: 14px;
      background: url("../../assets/invite/center.png");
      background-size: 100%;
      padding: 75px 0 0 231px;
      font-size: 14px;
      color: #333;
    }
    .detail{
      p{
        margin-bottom: 15px;
        span{
          color: #5E8FFC;
          font-size: 24px;
          font-family:DIN-Medium;
          font-weight:500;
          margin: 0 20px;
        }
      }
    }
    .invite{
      .s1{
        font-size: 12px;
        color: #666;
        margin: 0 20px 0 10px;
        padding-left: 10px;
        display: inline-block;
        width: 360px;
        height: 28px;
        line-height: 28px;
        border: 1px solid #D3D3D3;
        border-radius: 4px;
      }
      /deep/.ivu-btn{
        width: 100px;
        height: 36px;
        background:linear-gradient(-90deg,rgba(74,112,242,1) 0%,rgba(129,169,250,1) 100%);
        border-radius:10px;
        color: #fff;
        span{
          vertical-align: baseline;
        }
      }
    }
    .activeBtn{
      padding-top: 70px;
      /deep/.ivu-btn{
        width:200px;
        height:64px;
        background:linear-gradient(270deg,rgba(255,129,58,1) 0%,rgba(249,195,72,1) 100%);
        border-radius:32px;
        color: #fff;
        font-size: 24px;
      }
      .b2{
        background:linear-gradient(-90deg,rgba(74,112,242,1) 0%,rgba(129,169,250,1) 100%);
        margin-left: 290px;
      }
    }
    .record-list{
      margin: 30px 0 50px 10px;
      .s1{
          display: inline-block;
          margin-right: 100px;
          padding: 10px 0px;
          font-size: 18px;
          color: #666;
          font-family: SourceHanSansCN-Regular;
          position: relative;
          cursor: pointer;
      }
      .active{
        color: #5E8FFC;
         &:before {
          position: absolute;
          left: 0;
          bottom: -1px;
          height: 4px;
          background: #5E8FFC;
          width: 100%;
          display: block;
          content: "";
        }
      }
      .ir-list{
        margin-top: 20px;
      }
    }
  }
}
</style>


